import React from "react";
import { useLocation } from "react-router-dom";
import LinkButton from "@atom/LinkButton";
import style from "./style.scss";
import cn from "classnames";

const route = [
  { link: "fact-sheets", label: "Fact sheets" },
  { link: "how-to-be-an-ally", label: "How to be an ally" },
  { link: "resource-guides", label: "Resource guide" },
  { link: "transgender-support", label: "Transgender support" },
  { link: "terminology-&-pronouns", label: "Terminology & Pronouns" },
  { link: "poster-&-flyer", label: "Poster & Flyer" },
  { link: "emails", label: "Email & Logo" },
  { link: "media", label: "Social media" },
  { link: "worksheet", label: "Worksheet" },
  { link: "podcasts", label: "Podcasts" },
  { link: "fact-sheets", label: "Facts" },
  {
    link: "substance-use-and-the-LGBTQ+-community",
    label: "Substance use and the LGBTQ+ community",
  },
  {
    link: "beyond-the-binary-understanding-the-diversity-of-gender-and-gender-affirming-care",
    label:
      "Beyond the binary: Understanding the diversity of gender and gender affirming care",
  },
  {
    link: "changing-perspectives-generational-differences-in-the-LGBTQ+-community",
    label:
      "Changing perspectives: Generational differences in the LGBTQ+ community",
  },
  {
    link: "creating-welcoming-environments-inclusive-language",
    label: "Creating welcoming environments: Inclusive language",
  },
];

export default ({ className }) => {
  let location = useLocation().pathname;
  const first = location.split("/")[1];
  const second = location.split("/")[2];

  const firstLabel = route.filter((item) => item.link == first)?.[0]?.label;
  const secondLabel = route.filter((item) => item.link == second)?.[0]?.label;

  return (
    <div className={cn(style.breadcrumbs, className)}>
      <LinkButton to={"/"} className={cn(style.linkButton)}>
        {"Home"}
      </LinkButton>
      <label>/</label>
      {second ? (
        <>
          <label />
          <LinkButton
            to={"/" + first}
            className={cn(style.linkButton, style.first)}
          >
            {firstLabel}
          </LinkButton>
          <label>/</label>
          <label className={cn(style.second)}>{secondLabel}</label>
        </>
      ) : (
        <label className={cn(style.only)}>{firstLabel}</label>
      )}
    </div>
  );
};
